const VehiclePurposeValues = {
    PLEASURE: 'P',
    BUSINESS: 'B',
};

export default VehiclePurposeValues;
